import React, { useState } from 'react';
import { Info } from 'lucide-react';

const InfoBox = ({ text, position = 't', classes = '', size = 18 }) => {
    const [isVisible, setIsVisible] = useState(false);

    const getPopupClasses = () => {
        const baseClasses = 'absolute text-center bg-gray-100 dark:bg-neutral-900 text-black dark:text-white border border-gray-300 dark:border-gray-600 rounded-md p-2 shadow-md min-w-[200px] max-w-[300px] text-sm font-normal leading-none z-99999';
        switch (position) {
            case 't':
                return `${baseClasses} bottom-full left-1/2 transform -translate-x-1/2`;
            case 'r':
                return `${baseClasses} left-full top-1/2 transform -translate-y-1/2`;
            case 'b':
                return `${baseClasses} top-full left-1/2 transform -translate-x-1/2`;
            case 'l':
                return `${baseClasses} right-full top-1/2 transform -translate-y-1/2`;
            default:
                return baseClasses;
        }
    };

    return (
        <div className={`relative inline-block ${classes}`}>
            <button
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                className="cursor-help p-0 inline-flex items-center text-blue-600"
            >
                <Info size={size} />
            </button>

            {isVisible && (
                <div className={getPopupClasses()}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default InfoBox;